import{formatCPFCNPJ as r}from"../../../internal/SocialSecurityNumberBrazil/utils.js";const i={socialSecurityNumber:i=>r(i)};export{i as boletoFormatters};
//# sourceMappingURL=utils.js.map
